<template>
<div>
  <div class="content">
    <van-cell-group>
      <van-cell title="车头号" :value="detail.chetouhao" :title-class="titleClass" :value-class="valueClass" />
      <van-cell title="所属车队" :value="detail.sscd" :title-class="titleClass" :value-class="valueClass" />
      <div v-show="vehicleUsageName">
        <van-cell title="车辆证件用途" :value="vehicleUsageName" :title-class="titleClass" :value-class="valueClass" />
      </div>
      
      <van-cell title="车头质量" :value="detail.ctzl?detail.ctzl:0" :title-class="titleClass" :value-class="valueClass">
        <template #extra>
          <div class="unit">KG</div>
        </template>
      </van-cell>

      <van-cell title="整备质量" :value="detail.zhengbeizhiliang?detail.zhengbeizhiliang:0" :title-class="titleClass" :value-class="valueClass">
        <template #extra>
          <div class="unit">KG</div>
        </template>
      </van-cell>

      <van-cell title="总质量" :value="detail.zongzhiliang?detail.zongzhiliang:0" :title-class="titleClass" :value-class="valueClass">
        <template #extra>
          <div class="unit">KG</div>
        </template>
      </van-cell>

      <van-cell title="行驶证核定载质量" :value="detail.xingshizhenghdzzl?detail.xingshizhenghdzzl:0" :title-class="titleClass" :value-class="valueClass">
        <template #extra>
          <div class="unit">吨</div>
        </template>
      </van-cell>

      <van-cell title="行驶证有效期" :value="detail.xingshizhengyxq" :title-class="titleClass" :value-class="valueClass" />
      <div v-if="detail.xingshizhengzbfmurl">
        <van-cell title="行驶证正页" :title-class="titleClass" />
        <div class="imageBox">
          <van-image :src="detail.xingshizhengzbfmurl" />
        </div>
      </div>
      <div v-if="detail.xingshizhengfbzmurl">
        <van-cell title="行驶证副页" :title-class="titleClass" />
        <div class="imageBox">
          <van-image :src="detail.xingshizhengfbzmurl" />
        </div>
      </div>
      <div v-if="detail.xingshizhengfbfmurl" :title-class="titleClass">
        <van-cell title="行驶证副页反面" />
        <div class="imageBox">
          <van-image :src="detail.xingshizhengfbfmurl" />
        </div>
      </div>
      <div v-if="detail.xingshizhengzbzmurl">
        <van-cell title="行驶证机动车照片"/>
        <van-image  :src="detail.xingshizhengzbzmurl"/>
      </div>
      <div v-if="detail.vehicleUsage == '2'">
        <van-cell title="道路运输证有效期" :value="detail.daoluyszyxq" :title-class="titleClass" :value-class="valueClass" />
        <van-cell title="道路运输证经营范围" :value="detail.daoluyszjyfw" :title-class="titleClass" :value-class="valueClass" />

        <div v-if="detail.daoluyszzbzmurl">
          <van-cell title="道路运输证正本正面图片" :title-class="titleClass" />
          <div class="imageBox">
            <van-image :src="detail.daoluyszzbzmurl" />
          </div>
        </div>
        <div v-if="detail.daoluyszdlzmurl">
          <van-cell title="道路运输证（待理证）正面图片" :title-class="titleClass" />
          <div class="imageBox">
            <van-image :src="detail.daoluyszdlzmurl" />
          </div>
        </div>
        <div v-if="detail.daoluyszdlfmurl">
          <van-cell title="道路运输证（待理证）反面图片" :title-class="titleClass" />
          <div class="imageBox">
            <van-image :src="detail.daoluyszdlfmurl" />
          </div>
        </div>
      </div>
      
      <van-cell title="备注" :value="detail.beizhu" :title-class="titleClass" :value-class="valueClass" />
    </van-cell-group>
  </div>
  <Tabbar></Tabbar>
</div>
</template>

<script>
import api from '@/fetch/api'
import {
  Toast
} from 'vant';
import Tabbar from '../Public/tabbarTpl.vue'
export default {
  components: {
    Tabbar
  },
  data() {
    return {
      vehicleUsageName:"",
      id: "",
      detail: [],
      titleClass: "title-class-hq",
      valueClass: "value-class-hq",
    }
  },
  created() {
    document.title = "车头信息详情";
    this.getChetouBeianDetail();

  },
  methods: {
    getUsage(typecode)
    {
      var that = this;
      var typeGroupName = "vehicleUsage";
      api.getTypeList(typeGroupName).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.success == true) {
          var result = resData.obj;
          that.resultList = result;
          result.forEach((item) => {
            if(typecode == item.typecode) that.vehicleUsageName = item.typename;
            
          });
        } else {
          Toast.fail(resData.message);
        }
      }).catch(function() {
        //
      });
    },
    getChetouBeianDetail() {
      var that = this;
      var weburl = that.GLOBAL.weburl;
      var openid = that.$store.state.wx_info.openid;
      api.getChetouBeianDetail(openid).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var detail = res.data;
          detail.xingshizhengzbzmurl = detail.xingshizhengzbzmurl ? weburl + '/' + detail.xingshizhengzbzmurl : "";
          detail.xingshizhengzbfmurl = detail.xingshizhengzbfmurl ? weburl + '/' + detail.xingshizhengzbfmurl : "";
          detail.xingshizhengfbzmurl = detail.xingshizhengfbzmurl ? weburl + '/' + detail.xingshizhengfbzmurl : "";
          detail.xingshizhengfbfmurl = detail.xingshizhengfbfmurl ? weburl + '/' + detail.xingshizhengfbfmurl : "";
          detail.daoluyszzbzmurl = detail.daoluyszzbzmurl ? weburl + '/' + detail.daoluyszzbzmurl : "";
          detail.daoluyszdlzmurl = detail.daoluyszdlzmurl ? weburl + '/' + detail.daoluyszdlzmurl : "";
          detail.daoluyszdlfmurl = detail.daoluyszdlfmurl ? weburl + '/' + detail.daoluyszdlfmurl : "";
          if(detail.vehicleUsage) that.getUsage(detail.vehicleUsage)
          that.$data.detail = detail;
        }
      }).catch(function() {
        Toast.fail('连接失败，请刷新页面');
      });
    },
  }
}
</script>

<style lang="scss" scoped>
html {
    background: #fff;
}
.content {
    margin-top: 1rem;
    margin-bottom: 3.75rem;
    padding-bottom: env(safe-area-inset-bottom);
    .imageBox {
        margin: 0 1rem;
        padding: 0.875rem 0;
        border: 1px solid #ebedf0;
    }
}

.unit {
    padding-left: 0.2rem;
    color: #969799;
}
</style>
